import api from "../Utils/axios";
import { filterParams } from "../Utils/helpers";

const ACCOUNT_STATE_FILTERS = ["deletion_pending", "deleted"];

export const USER_STATUS_FILTER_OPTIONS = [
    { value: true, label: "Active" },
    { value: false, label: "Inactive" },
    { value: "deletion_pending", label: "Deletion pending" },
    { value: "deleted", label: "Deleted" },
];

export const getAllUsers = (
    page,
    perPage,
    role = "user",
    search_string,
    status,
    from,
    to,
    adminApproved
) => {
    const isAccountState = ACCOUNT_STATE_FILTERS.includes(status);
    return api.get(`/user/get`, {
        params: filterParams({
            page,
            limit: perPage,
            role,
            keyword: search_string,
            active: isAccountState ? undefined : status,
            accountState: isAccountState ? status : undefined,
            adminApproved,
            "createdAt[from]": from,
            "createdAt[to]": to,
        }),
    });
};

export const getUserDetails = (id) => {
    return api.get(`/user/get`, {
        params: {
            _id: id,
        },
    });
};

export const getBusinessMuvvrDetails = (id) => {
    return api.get(`/signup-requests/myMuvvrs`, {
        params: {
            _id: id,
        },
    });
};

/**
 * @param {string} id
 * @param {{ action?: 'after_ride'|'cancel_ride'|'reassign_ride'|'undo_scheduled', reason?: string }} [body]
 */
export const changeUserStatus = (id, body = {}) => {
    return api.post(`/user/handle-status/${id}`, body);
};

/**
 * Schedules the account for deletion (same checks as the apps; the user can restore by logging in during the grace period).
 * @param {string} id
 * @param {{ reason?: string }} [body]
 */
export const deleteUserAccount = (id, body = {}) => {
    return api.post(`/user/delete-account/${id}`, body);
};

export const restoreUserAccount = (id) => {
    return api.post(`/user/restore-account/${id}`);
};

export const getUserActiveRide = (id) => {
    return api.get(`/user/active-ride/${id}`);
};

export const updateDriverDocumentExpiry = (id, body) => {
    return api.post(`/user/document-expiry/${id}`, body);
};
